module.exports = __webpack_public_path__ + "static/media/absence.d8978565.svg";